import option from "./option";
export default option;


// WEBPACK FOOTER //
// /src/call/container/mcq/option/index.js